import { makeService } from './api';

export default makeService('frontend_groups');
